import { resolveReportProfilePreviewSections } from './reportLayoutMaps';
import type { ReportProfilePreviewSectionsProps } from './types/ReportProfilePreviewSectionsProps';

const ReportProfilePreviewLayout = (
  props: ReportProfilePreviewSectionsProps,
) => {
  const Sections = resolveReportProfilePreviewSections(
    props.cardType,
    props.pageType,
  );

  return <Sections {...props} />;
};

export default ReportProfilePreviewLayout;
